<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-18 14:03:53
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-21 18:02:40
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\rulesSetting\viewRules\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="view-rules" :class="{ comingSoon: $isPlatOr(platformId, ['Sp']) }">
			<platformTab @change="handleClick" :showAll="false" :platformId="platformId" />
			<template v-if="$isPlatOr(['Dy', 'Ks'])">
				<div v-show="showPlatformContent">
					<div class="flex-row-align-center" v-if="isWaitTask">
						<div class="yx-color-warning font-h4-regular">部分数据正在订正中，暂不支持修改规则，请耐心等待…</div>
					</div>
					<div class="mt-16">
						<el-button type="primary" @click="editRules">修改规则</el-button>
					</div>
					<ruleItem>
						<div slot="title" class="flex-row-align-center">
							<i class="i-coll-rule1"></i>
							<span class="font-h4-medium ml-6 mr-4">{{ `是否允许多个${drName}跟进同一团长` }}</span>
						</div>
						<div class="ruleList_item_content">
							<div class="font-h4-regular mb-8">{{ collaborateText }}</div>
						</div>
						<div slot="ruleText">
							<p>
								1、若同个团长仅允许1个{{ drName }}跟进，系统会校验关系的唯一性，团长被录入/认领后，其他{{
									drName
								}}无法再录入/认领。同时该场景下团队所出订单会按{{ drName }}认领关系去进行归属
							</p>
							<p>
								2、若同个团长允许多个{{ drName }}跟进，则系统会根据合作进度(商品、团长信息匹配)来归属业绩，对于未归属订单可在[订单管理]进行手动分配；
							</p>
							<p>
								3、{{ drName }}与团长跟进关系从多对1切换到1对1时，若存在多个{{
									drName
								}}同时跟进某个团长，管理员需为其指定1位最终跟进人。后续业绩归属也按唯一跟进人匹配，已归属订单业绩不会改动。
							</p>
						</div>
					</ruleItem>
				</div>
			</template>
			<div class="flex flex-just-center align-center" style="margin-top: 100px" :class="{ emptySPBox: $isPlatOr(platformId, ['Sp']) }" v-else>
				<emptyPage ref="emptyPage">
					<img slot="image" src="@/assets/public/dev-img.png" alt="" />
					<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
				</emptyPage>
			</div>
		</Panel>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import ruleItem from '@/components/business/ruleItem';
import { drRoleType } from '@/utils/dataMap';
import { GetRule } from '@/api/secondColonelManage';
import { platformMixin } from '@rd/rd-ui';
import emptyPage from '@/views/common/empty/index.vue';
export default {
	components: {
		ruleItem,
		emptyPage,
	},
	computed: {
		...mapGetters(['defaultPlatform']),
		drName() {
			return drRoleType.name;
		},
		collaborateText({ manyPartnerToInstitution }) {
			const obj = {
				0: '不允许',
				1: '允许',
			};
			return obj[manyPartnerToInstitution];
		},
	},
	data() {
		return {
			platformId: '',
			isWaitTask: '',
			manyPartnerToInstitution: '0',
		};
	},
	mixins: [platformMixin],
	created() {
		this.platformId = +this.$route.query.platformId || +this.defaultPlatform;
		this.GetRule();
	},
	methods: {
		async GetRule() {
			const { platformId } = this;
			const { manyPartnerToInstitution = '1', isWaitTask = false } = await GetRule({ platformId });
			this.manyPartnerToInstitution = `${manyPartnerToInstitution}`;
			this.isWaitTask = isWaitTask;
		},
		editRules() {
			this.$router.push('/secondColonelManage/rulesSetting/editRules?platformId=' + this.platformId);
		},
		handleClick(val) {
			this.platformId = val;
			this.GetRule();
		},
	},
};
</script>
